import { PaginatedRequestParams, PaginatedResponse } from "../../../../common/pagination";
import { ProductQuantityLimitationRepository, StoreProductQuantityLimitation } from "../data";

export class StoreProductQuantityLimitationService {

    private readonly repo: ProductQuantityLimitationRepository;

    constructor() {
        this.repo = new ProductQuantityLimitationRepository();
    }


    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<StoreProductQuantityLimitation>> {

        return this.repo.search(request);
    }
    public getDetails(id: number): Promise<StoreProductQuantityLimitation> {
        return this.repo.getDetails(id);
    }
    public delete(id: number): Promise<boolean> {
        return this.repo.delete(id);
    }

    public deleteAll(ids: number[]): Promise<boolean> {
        return this.repo.deleteAll(ids);
    }

    public createOrUpdate(data: StoreProductQuantityLimitation): Promise<StoreProductQuantityLimitation> {
        return this.repo.createOrUpdate(data);
    }
}